/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AnalyzeSetRequest,
  QuotaError,
  SetWithManufacturer,
} from '../models/index';
import {
    AnalyzeSetRequestFromJSON,
    AnalyzeSetRequestToJSON,
    QuotaErrorFromJSON,
    QuotaErrorToJSON,
    SetWithManufacturerFromJSON,
    SetWithManufacturerToJSON,
} from '../models/index';

export interface AnalyzeSetOperationRequest {
    id: string;
    analyzeSetRequest: AnalyzeSetRequest;
}

export interface GetSetByIdRequest {
    id: string;
}

export interface GetSetsRequest {
    manufacturer?: string;
    status?: GetSetsStatusEnum;
    search?: string;
}

/**
 * 
 */
export class SetsApi extends runtime.BaseAPI {

    /**
     * Startet eine Analyse für ein Set mit dem angegebenen Analyse-Typ
     * Set-Analyse starten
     */
    async analyzeSetRaw(requestParameters: AnalyzeSetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetWithManufacturer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling analyzeSet.');
        }

        if (requestParameters.analyzeSetRequest === null || requestParameters.analyzeSetRequest === undefined) {
            throw new runtime.RequiredError('analyzeSetRequest','Required parameter requestParameters.analyzeSetRequest was null or undefined when calling analyzeSet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sets/{id}/analyze`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AnalyzeSetRequestToJSON(requestParameters.analyzeSetRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetWithManufacturerFromJSON(jsonValue));
    }

    /**
     * Startet eine Analyse für ein Set mit dem angegebenen Analyse-Typ
     * Set-Analyse starten
     */
    async analyzeSet(requestParameters: AnalyzeSetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetWithManufacturer> {
        const response = await this.analyzeSetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gibt Details eines spezifischen Sets zurück
     * Set-Details
     */
    async getSetByIdRaw(requestParameters: GetSetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetWithManufacturer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSetById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sets/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetWithManufacturerFromJSON(jsonValue));
    }

    /**
     * Gibt Details eines spezifischen Sets zurück
     * Set-Details
     */
    async getSetById(requestParameters: GetSetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetWithManufacturer> {
        const response = await this.getSetByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gibt alle analysierten Sets zurück (flache Liste)
     * Liste aller Sets
     */
    async getSetsRaw(requestParameters: GetSetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SetWithManufacturer>>> {
        const queryParameters: any = {};

        if (requestParameters.manufacturer !== undefined) {
            queryParameters['manufacturer'] = requestParameters.manufacturer;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SetWithManufacturerFromJSON));
    }

    /**
     * Gibt alle analysierten Sets zurück (flache Liste)
     * Liste aller Sets
     */
    async getSets(requestParameters: GetSetsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SetWithManufacturer>> {
        const response = await this.getSetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetSetsStatusEnum = {
    All: 'all',
    Safe: 'safe',
    Unsafe: 'unsafe',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type GetSetsStatusEnum = typeof GetSetsStatusEnum[keyof typeof GetSetsStatusEnum];
